<div ngbDropdown [formGroup]="parent">
  <div class="form-group has-float-label" formGroupName="orderHeader">
    <label class="form-label">Buyer</label>
    <input
      pInputText
      #mydrop
      jniAutoCompleteBlocker
      autocomplete="off"
      type="text"
      id="buyer"
      name="buyer"
      class="form-control"
      maxlength="50"
      [value]="buyerName"
      (input)="buyerVendor$.next($any($event.target).value)"
      (keyup)="onBuyerSearchOpenToggle(buyerQoutePopover, $event, mydrop)"
      (keydown.Tab)="getBuyer($event, buyerQoutePopover)"
      (blur)="logValidationErrors()"
      (click)="onContactList(buyerQoutePopover, $event, mydrop)"
      formControlName="buyer" />
  </div>
  <p-popover
    class="order-dropdown add"
    #buyerQoutePopover
    aria-labelledby="dropdownBasic1">
    <p-table
      #dt
      [value]="buyerLists"
      styleClass="p-datatable-customers order-listing"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [filterDelay]="0"
      scrollHeight="calc(100vh - 310px)"
      [size]="'small'"
      [resizableColumns]="true"
      scrollHeight="290px">
      <ng-template pTemplate="header">
        <tr>
          <th class="name">Buyer</th>
          <th class="client" pSortableColumn="client">
            Client
            <p-sortIcon field="Client"></p-sortIcon>
          </th>
          <th class="vaccount">Account</th>
          <th class="street">Street</th>
          <th class="city">City</th>
          <th class="state">State</th>
          <th class="lastOrderDate">Last order date</th>
        </tr>
        <tr>
          <th>
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="buyer"
                id="buyerFilter"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'buyer',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="organizationNameD365"
                id="organizationNameD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'organizationNameD365',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-buyerList let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row mousepointer"
          (click)="onBuyerSelection(buyerList, buyerQoutePopover)">
          <td class="buyer mousepointer">
            {{ buyerList.buyer }}
          </td>
          <td class="client mousepointer">
            {{ buyerList.organizationNameD365 }}
          </td>
          <td class="vaccount mousepointer">
            {{ buyerList.account }}
          </td>
          <td style="width: 200px" class="sname mousepointer">
            {{ buyerList.street }}
          </td>
          <td class="city mousepointer">{{ buyerList.city }}</td>
          <td style="width: 72px" class="state mousepointer">
            {{ buyerList.state }}
          </td>
          <td style="width: 75px" class="country mousepointer">
            {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No buyer found.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-popover>
</div>
